<template>
  <div class="p-0">
    <h3 v-translate:license_info="lang" class="text-center">
      License Information
    </h3>
    <div id="license" v-if="license" class="pl-40 pr-40 pt-20">
      <div class="card-body p-0">
        <div v-html="license"></div>
      </div>
    </div>
    <div v-else>
      <div class="card-body">
        <p class="mt-30" v-translate:loading="lang">Loading...</p>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import { Bitrise } from "@/components/services/participant-service";

export default {
  name: "license-information",
  data() {
    return {
      license: "",
      pid: "",
      globalElement: null
    };
  },
  mounted() {
    this.loadContent();
  },
  computed: {
    ...mapGetters(["participant", "token"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  methods: {
    loadContent() {
      nprogress.start();
      const bitrise = new Bitrise();
      bitrise
        .getLicense()
        .then(html => {
          nprogress.done();
          this.license = html.body.innerHTML;
        })
        .catch(() => {
          nprogress.done();
        });
    }
  }
};
</script>
